module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chap",
    attrs: {
      "epub:type": "chapter",
      "id": "chap-002"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_9",
      "title": "9"
    }
  }, [_c('h1', {
    staticClass: "chap_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_c('img', {
    staticClass: "imagelarge_intext",
    attrs: {
      "alt": "",
      "id": "fig-chap2",
      "src": "images/fig-chap2.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Petroleum in its most common liquid form is referred to as"), _c('i', [_vm._v(" crude oil")]), _vm._v(". It is extracted from the earth by drilling into geologic structures (described in "), _c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap1#chap-001"
    }
  }, [_vm._v("chap. 1")]), _vm._v(") whose properties are conducive to the aggregation of oil.")]), _vm._v(" "), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-006"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("General Composition of Crude Oil")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Petroleum consists mostly of hydrocarbon molecules, themselves made up of various combinations of hydrogen and carbon atoms. The simplest hydrocarbon molecule—one carbon atom bonded to four hydrogen atoms (CH"), _c('sub', [_vm._v("4")]), _vm._v(" )—is called"), _c('i', [_vm._v(" methane")]), _vm._v(" and is the primary component of natural gas. More details about this form of hydrocarbon are given in "), _c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap3#chap-003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 3")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Crude oil is a mixture of a very large number of hydrocarbons with arcane names such as"), _c('i', [_vm._v(" alkanes")]), _vm._v(" (or paraffins),"), _c('i', [_vm._v(" cycloalkanes")]), _vm._v(" (or naphthenes),"), _c('i', [_vm._v(" aromatic")]), _vm._v(" hydrocarbons, and"), _c('i', [_vm._v(" asphaltenes")]), _vm._v(". A major distinguishing characteristic is the number of carbon atoms they contain. For example, asphalt contains 35 or more carbon atoms per molecule, while pentane (used to make gasoline) has just 5. (Both are classified as alkanes.) The type, variety, and structure of the hydrocarbon molecules in crude oil determine its physical and chemical properties, such as color, thickness (viscosity),and boiling point. Crude oil also may contain nitrogen,oxygen and sulfur, plus trace amounts of metals such as iron, nickel, copper, and vanadium. In general terms, crude oil contains about 83%–87% carbon, 10%–14% hydrogen, 0.1%–2% nitrogen, 0.1%–1.5% oxygen, and less than 0.1% metals.")])]), _vm._v(" "), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-007"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_10",
      "title": "10"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Conventional Crude Oil")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Crude oil is often found along with natural gas and saline (salty) water. The lighter natural gas forms a gas cap over the petroleum, while the saline water is heavier than most forms of crude and generally sinks beneath it. Conventional oil resources are those whose location and extent have been quite well established, that can be produced through wellbores using relatively standard equipment and procedures, and that typically require minimal processing prior to sale.")]), _vm._v(" "), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-004"
    }
  }, [_c('h3', {
    staticClass: "int_niv2",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Classiﬁcation scheme")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The petroleum industry uses three major parameters to classify crude oil:")]), _vm._v(" "), _c('ul', {
    staticClass: "liste_puce"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_vm._v("Geographic location in which it is produced (which affects the cost of transporting the crude to a refinery).")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_vm._v("API gravity (an oil industry measure of density; API is the American Petroleum Institute). Light crude oil has relatively low density; heavy crude has high density. Oil with an API gravity (expressed as ºAPI) below 10.0 is classified as extraheavy.")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_vm._v("Sulfur content. Crude is generally called"), _c('i', [_vm._v(" sweet")]), _vm._v(" if it contains relatively little sulfur or"), _c('i', [_vm._v(" sour")]), _vm._v(" if it contains substantial amounts.")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Light crude oil is more desirable than heavy oil because it produces a higher yield of gasoline, a highly valued petroleum product for transportation use. Sweet oil commands a higher price than sour oil because it has fewer environmental problems and requires less refining to meet sulfur-content standards imposed by buyers. Table 2–1 shows the API gravity and sulfur content of some benchmark crude oil (described in the next section).")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Each crude oil has unique molecular characteristics that are evaluated by a process called"), _c('i', [_vm._v(" assay analysis")]), _vm._v(", carried out in a laboratory.")])]), _vm._v(" "), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-005"
    }
  }, [_c('h3', {
    staticClass: "int_niv2",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Benchmark crudes")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Oil from an area in which its molecular characteristics have been determined is used as a pricing reference, or"), _c('i', [_vm._v(" benchmark")]), _vm._v(", in global oil markets. Some common reference crudes are:")]), _vm._v(" "), _c('ul', {
    staticClass: "liste_puce"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('i', [_vm._v("West Texas Intermediate")]), _vm._v(" (WTI), a very high quality sweet, light oil delivered at Cushing, Oklahoma, for North American oil. Cushing is the delivery point for WTI traded on the New York Mercantile Exchange (NYMEX), the most widely traded oil futures contracts in the world."), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_11",
      "title": "11"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau",
    attrs: {
      "id": "tab-002"
    }
  }, [_c('div', {
    staticClass: "tabtit"
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "mev1"
  }, [_vm._v("Table 2–1.")]), _vm._v(" Properties of selected crude oils")])]), _vm._v(" "), _c('div', {
    staticClass: "table-align"
  }, [_c('table', {
    staticStyle: {
      "border-collapse": "collapse",
      "border-spacing": "0px"
    }
  }, [_c('colgroup', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('col', {
    staticStyle: {
      "width": "37%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "19%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "padding": "1px"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px",
      "background-color": "#b9813d"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche",
    staticStyle: {
      "color": "#ffffff"
    }
  }, [_c('b', [_vm._v("Crude type")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px",
      "background-color": "#b9813d"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre",
    staticStyle: {
      "color": "#ffffff"
    }
  }, [_c('b', [_vm._v("Country")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px",
      "background-color": "#b9813d"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre",
    staticStyle: {
      "color": "#ffffff"
    }
  }, [_c('b', [_vm._v("Gravity, ºAPI")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px",
      "background-color": "#b9813d"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre",
    staticStyle: {
      "color": "#ffffff"
    }
  }, [_c('b', [_vm._v("Sulfur content,%")])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Arabian Light")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_vm._v("Saudi Arabia")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_vm._v("33.4")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_vm._v("1.80")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Bachequero")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_vm._v("Venezuela")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_vm._v("16.8")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_vm._v("2.40")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Bonny Light")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_vm._v("Nigeria")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_vm._v("37.6")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_vm._v("0.13")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Brass River")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_vm._v("Nigeria")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_vm._v("43.0")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_vm._v("0.08")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Dubai")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_vm._v("Dubai (UAE)")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_vm._v("32.5")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_vm._v("1.68")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Ekoﬁsk")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_vm._v("Norway")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_vm._v("35.8")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_vm._v("0.18")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Iranian Light")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_vm._v("Iran")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_vm._v("33.5")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_vm._v("1.40")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Kuwait")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_vm._v("Kuwait")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_vm._v("31.2")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_vm._v("2.50")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("North Slope (Alaska)")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_vm._v("US")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_vm._v("26.8")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_vm._v("1.04")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px",
      "border-bottom": "1px solid #b9813d"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("WTI"), _c('sup', [_vm._v("a")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px",
      "border-bottom": "1px solid #b9813d"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_vm._v("US")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px",
      "border-bottom": "1px solid #b9813d"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_vm._v("38–40")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px",
      "border-bottom": "1px solid #b9813d"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_vm._v("0.24")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau_source"
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('i', [_vm._v("Source:")]), _vm._v(" Hyne, N. J.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant"
  }, [_c('sup', [_vm._v("a")]), _vm._v(" West Texas Intermediate.")])])]), _vm._v(" "), _c('ul', {
    staticClass: "liste_puce"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('i', [_vm._v("Brent Blend")]), _vm._v(", made up of 15 oils from fields in the Brent and Ninian systems in the East Shetland Basin of the North Sea. Oil production from Europe and Africa, as well as Middle Eastern oil flowing to the West, tends to be priced using this benchmark.")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('i', [_vm._v("Dubai-Oman")]), _vm._v(", used as benchmark for Middle East sour crude flowing to the Asia-Pacific region.")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('i', [_vm._v("OPEC Reference Basket")]), _vm._v(", a weighted average of oils and blends from the 12 nations that make up the Organization of the Petroleum Exporting Countries.")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('i', [_vm._v("Midway-Sunset Heavy")]), _vm._v(", by which heavy oil in California is priced. Midway-Sunset is a large oil field in Kern County, California.")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Declining amounts of these benchmark oils are being produced each year, so other oils are more commonly what is actually delivered. For example, while a reference price may be for WTI delivered at Cushing, the actual oil being traded may be a Canadian heavy oil delivered at Hardisty, Alberta.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In early February 2011, the"), _c('i', [_vm._v(" Financial Times")]), _vm._v(" noted the continuing decline in the dominance of the WTI benchmark in global oil pricing. Because of increasing crude inventories at Cushing, the WTI price had weakened substantially compared to crudes of comparable quality, such as Brent Blend and Light Louisiana Sweet.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_12",
      "title": "12"
    }
  }, [_vm._v("At one point in early February 2011, Brent’s premium over WTI reached a record level of more than $16 per barrel. Such discrepancies upset the plans of energy investors and traders. In fact, in 2009, Saudi Arabia dropped WTI as its benchmark for pricing oil for sale to customers in the United States.")])])]), _vm._v(" "), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-006"
    }
  }, [_c('h3', {
    staticClass: "int_niv2",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Crude oil prices")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("A brief word is warranted about crude prices, which jumped about 30% between January and early April 2011. (On April 11, 2011, the Brent price reached a 2.5-year high of $127.02 per barrel, with WTI at $112.79.) Driving fears of further increases were concerns about chaotic geopolitics in several oil-producing countries, including:")]), _vm._v(" "), _c('ul', {
    staticClass: "liste_puce"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_vm._v("Actions aimed at ousting long-standing regimes in North Africa—from Tunisia and Egypt to Libya, Syria, and Algeria—as well as unrest in Yemen and Saudi Arabia.")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_vm._v("Continuing civil disorder in Nigeria, a major global source of highly prized light, sweet crude oil.")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_vm._v("Increased domestic spending in some of these nations (e.g., $125 billion in Saudi Arabia) in an attempt to quell discontent, which might then be made up by charging more for exported oil.")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_vm._v("Continued use of domestic fuel subsidies in many oil-producing countries, which tend to drive up internal demand and reduce oil volumes available for export.")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Also contributing to concerns about future price and supply was rising oil demand in China, already the world’s second-largest oil consumer in 2010. Some analysts were projecting that oil consumption in China would top 10 million barrels per day (b/d) in 2011.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("A counterbalance to upward price pressure was a slowing global economy. By mid-August 2011, the crude oil futures contract price on the NYMEX had fallen back to $80–$85 per barrel.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("However, Middle Eastern geopolitics again pushed up oil prices in early 2012. On January 23, the price of NYMEX crude for March delivery rose to $99.58 per barrel, driven in part by a decision that day by European Union governments to ban imports of oil from Iran (effective July 1, 2012) and to freeze Europe-based assets of Iran’s central bank. (Approximately 20% of Iranian oil exports go to EU nations.)")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The EU action was part of an international campaign to pressure Iran to resume talks on the country’s nuclear development program.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_13",
      "title": "13"
    }
  }, [_vm._v("In response, some Iranian lawmakers threatened to close the Strait of Hormuz, a narrow passage between Iran and Oman and a critical route for tankers that carry oil from the Persian Gulf to world markets.")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-008"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Unconventional Crude Oil")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Several types of oil resources are called unconventional, to distinguish them from oil that can be extracted using traditional oil field methods. These include"), _c('i', [_vm._v(" tar sands")]), _vm._v(" (also called"), _c('i', [_vm._v(" oil sands")]), _vm._v(") and"), _c('i', [_vm._v(" shale oil")]), _vm._v(".")]), _vm._v(" "), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-007"
    }
  }, [_c('h3', {
    staticClass: "int_niv2",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Tar sands/oil sands")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Crude oil is sometimes found in semisolid form, mixed with sand and water. Major deposits of oil of this type are found in the Athabasca region of northeastern Alberta. Tar sands contain"), _c('i', [_vm._v(" bitumen")]), _vm._v("—a kind of heavy crude oil. The sticky, black, tarlike material is so thick that it must be heated or chemically diluted before it will flow. Oil-eating bacteria have destroyed some of the lighter fractions of crude oil in such oil sands, leaving behind the heavier bitumen fractions.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Venezuela also has large amounts of crude trapped in sands in that nation’s Orinoco region. These hydrocarbons have a somewhat lower viscosity (i.e., are less thick) than those in Canada and are usually called"), _c('i', [_vm._v(" heavy")]), _vm._v(" or"), _c('i', [_vm._v(" extraheavy")]), _vm._v(" oil.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Combined, Canada and Venezuela contain an estimated 3.6 trillion barrels (570 billion cubic meters) of bitumen and extraheavy oil. This represents about twice the volume of the world’s reserves of conventional oil."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "apnf",
    attrs: {
      "href": "#/chap2#NFIN1",
      "id": "ap_NFIN1-1"
    }
  }, [_vm._v("1")])])])]), _vm._v(" "), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-008"
    }
  }, [_c('h3', {
    staticClass: "int_niv2",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Shale oil")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Another unconventional resource, shale oil is found in shale source rock that has not been exposed to heat or pressure long enough to convert trapped hydrocarbons into crude oil. According to the U.S. Department of Energy (DOE), oil shales are not technically shales and do not really contain oil. Rather, they are usually relatively hard rocks called"), _c('i', [_vm._v(" marls")]), _vm._v("—composed primarily of clay and calcium carbonate—containing the waxy substance called kerogen (described in "), _c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap1#chap-001"
    }
  }, [_vm._v("chap. 1")]), _vm._v("). The trapped kerogen can be converted into crude oil using heat and pressure to simulate natural processes.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_14",
      "title": "14"
    }
  }, [_vm._v("Oil shales are found in many countries, but the United States has the world’s largest deposits. These are located chiefly in the Green River formation, which covers portions of Colorado, Utah, and Wyoming."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "apnf",
    attrs: {
      "href": "#/chap2#NFIN2",
      "id": "ap_NFIN2-1"
    }
  }, [_vm._v("2")])]), _vm._v(" DOE has estimated that as much as 800 billion barrels of oil are recoverable from that formation.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In addition, from 2008 to 2011, small and midsize companies stepped up exploration and production in several other regions, including the Bakken oil-bearing shale along the North Dakota/Montana border, the Permian Basin in West Texas, and the Eagle Ford formation in South Texas. The companies used two main techniques previously developed to extract natural gas from shale formations: the drilling of long horizontal wells to reach additional oil deposits; and hydraulic fracturing (fracing), in which water mixed with chemicals and other materials is pumped at high pressure into the ground to crack the rock and make it easier for oil to flow. Analysts have estimated that the United States could be producing an additional 2.5 million b/d of oil by 2016, with the increase coming equally from deepwater fields in the Gulf of Mexico and from new onshore sources.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("As the world’s reserves of conventional light and medium oil are depleted, oil refineries are investing in the more-complex and expensive systems needed to process increased volumes of heavy oil and bitumen. Heavier crude oils have too much carbon and not enough hydrogen, so these systems generally involve removing carbon or adding hydrogen, to convert the longer, more-complex molecules in the oil to the shorter, simpler ones that characterize end-product fuels. (More details of these processes are presented in "), _c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap11#chap-011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chap. 11")]), _vm._v(".)")])])]), _vm._v(" "), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-009"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Resources and Reserves")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("A brief discussion of oil resources and reserves is warranted here."), _c('i', [_vm._v(" Resources")]), _vm._v(" are hydrocarbons that may or may not be produced in the future. An initial estimate of the magnitude of the resource in a yet-to-be-drilled prospect may be made. However, appraisal (by drilling delineation wells or acquiring more seismic data, as described in "), _c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#chap-004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chap. 4")]), _vm._v(") is needed to confirm the size of a field and pave the way for development and production. Once the relevant government body gives an oil company a production license for field development, the reserves in the field can be formally booked.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_15",
      "title": "15"
    }
  }, [_vm._v("According to the Society of Petroleum Engineers (SPE), reserves are the quantities of crude oil estimated to be commercially recoverable by application of development efforts to known (discovered) accumulations, from a given date forward, under defined conditions. The total estimated amount of oil in a reservoir,including both producible and nonproducible oil, is called"), _c('i', [_vm._v(" oil in place")]), _vm._v(" (OIP). However, because of reservoir characteristics and the limits of extraction technologies, only a fraction of this oil can be brought to the surface. Only this producible fraction comprises the reserves. The ratio of producible oil reserves to total OIP for a given field is often referred to as the"), _c('i', [_vm._v(" recovery factor")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Reserves are further categorized by the level of certainty associated with the estimates of their magnitude. The following are the three categories in widest use:")]), _vm._v(" "), _c('ul', {
    staticClass: "liste_puce"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('i', [_vm._v("Proved")]), _vm._v(" reserves. These are considered reasonably certain to be producible using current technology at current prices, with current commercial terms and government consent. This category is also sometimes called 1P, but others in the industry refer to it as"), _c('i', [_vm._v(" P90")]), _vm._v("—that is, having a 90% certainty of being produced.")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('i', [_vm._v("Probable")]), _vm._v(" reserves. These are considered to have a reasonably probable chance of being produced using current or likely technology at current prices, with current commercial terms and government consent. This category is sometimes called"), _c('i', [_vm._v(" P50")]), _vm._v("—that is, having a 50% certainty of being produced—and is also known in the industry as"), _c('i', [_vm._v(" 2P")]), _vm._v(", meaning “proved plus probable.”")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('i', [_vm._v("Possible")]), _vm._v(" reserves. These have a chance of being developed under favorable circumstances. Some industry specialists refer to this as"), _c('i', [_vm._v(" P10")]), _vm._v("—that is, having a 10% certainty of being produced—while others use the term"), _c('i', [_vm._v(" 3P")]), _vm._v(", for “proved plus probable plus possible.”")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Experience has shown that initial estimates of the size of newly discovered oil fields are usually too low. The term"), _c('i', [_vm._v(" reserve growth")]), _vm._v(" refers to the increases in estimated ultimate recovery that occur as oil fields are developed and produced.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Known global oil reserves are estimated at about 1.2 trillion barrels (without oil sands) by the Energy Information Administration (EIA) of the DOE. The agency raises that figure to 3.74 trillion barrels if oil sands are included."), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_16",
      "title": "16"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "encfond",
    attrs: {
      "id": "enc-002"
    }
  }, [_c('p', {
    staticClass: "enc_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("Barrels of oil equivalent (boe)")])]), _vm._v(" "), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Energy companies and others sometimes use the parameter"), _c('i', [_vm._v(" barrels of oil equivalent")]), _vm._v(" (boe) as a way to report oil plus gas reserves or production as a single figure. Oil and gas from various sources release different amounts of energy when burned, but SPE provides the following information, based on typical heating values.")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Burning one barrel (42 gallons) of oil releases 5.8 million British thermal units (Btu). One Btu is the energy needed to raise the temperature of one pound of water one degree Fahrenheit at one atmosphere of pressure.")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("A typical figure for the heating value of natural gas is 1,025 Btu per cubic foot, according to SPE. Therefore, burning 5,658.53 cubic feet of gas would yield an equivalent amount of energy to burning one barrel of oil (5.8 million divided by 1,025). A company with gas reserves of 5,658.53 cubic feet and oil reserves of 10 barrels could then report its total reserves as 11 boe.")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The U.S. Geological Survey defines 1 boe as roughly equivalent to 6,000 cubic feet of typical natural gas. The French oil company Total uses a figure of 5,487 cubic feet.")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Table 2–2 lists those nations with the largest estimated oil reserves as of early 2012, as well as data on number of oil wells and oil production.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Figure 2–1 provides another perspective on global distribution of proved oil reserves. Table 2–3 lists the non–U.S.-based companies with the largest estimated oil production and reserves as of late 2011.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In a 2008 study, the U.S. Geological Survey estimated that the offshore Arctic region may hold 90 billion barrels of recoverable oil—almost one-fourth of the world’s unmapped reserves."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "apnf",
    attrs: {
      "href": "#/chap2#NFIN3",
      "id": "ap_NFIN3-1"
    }
  }, [_vm._v("3")])]), _vm._v(" About 65% is thought to be in Russian territorial waters.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Royal Dutch Shell separately estimated that the Arctic also holds about 30% of the world’s yet-to-be-found natural gas, according to a March 2011 news report."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "apnf",
    attrs: {
      "href": "#/chap2#NFIN4",
      "id": "ap_NFIN4-1"
    }
  }, [_vm._v("4")])]), _vm._v(" There has been some exploration of this vast resource but no development, although several nations (including Russia, Greenland, and the United States) are jockeying for position in planning for future activity. Major oil companies are doing the same, including Shell, Statoil, ExxonMobil, Chevron, BP, and the Russian state oil company, Rosneft."), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_17",
      "title": "17"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tableau",
    attrs: {
      "id": "tab-003"
    }
  }, [_c('div', {
    staticClass: "tabtit"
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "mev1"
  }, [_vm._v("Table 2–2.")]), _vm._v(" Nations with largest estimated oil reserves, 2012")])]), _vm._v(" "), _c('div', {
    staticClass: "table-align"
  }, [_c('table', {
    staticStyle: {
      "border-collapse": "collapse",
      "border-spacing": "0px"
    }
  }, [_c('colgroup', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('col', {
    staticStyle: {
      "width": "17%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "28%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "28%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "padding": "1px"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px",
      "background-color": "#b9813d"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche",
    staticStyle: {
      "color": "#ffffff"
    }
  }, [_c('b', [_vm._v("Country"), _c('sup', [_vm._v("a")])])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px",
      "background-color": "#b9813d"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre",
    staticStyle: {
      "color": "#ffffff"
    }
  }, [_c('b', [_vm._v("Estimated proved oil reserves as of January 1, 2012,"), _c('sup', [_vm._v("b")]), _vm._v(" billion barrels")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px",
      "background-color": "#b9813d"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre",
    staticStyle: {
      "color": "#ffffff"
    }
  }, [_c('b', [_vm._v("Producing oil wells as of December 31, 2010"), _c('sup', [_vm._v("c")])])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px",
      "background-color": "#b9813d"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre",
    staticStyle: {
      "color": "#ffffff"
    }
  }, [_c('b', [_vm._v("Estimated oil production in 2011, million b/d")])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Saudi Arabia")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("264.52")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("2,895")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("9.00")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Venezuela")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("211.17")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("14,651")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("2.51")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Canada")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("173.62")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("62,519")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("2.86")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Iran")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("151.17")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("2,074")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("3.58")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Iraq")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("143.10")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("1,526")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("2.48")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Kuwait")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("101.50")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("1,286")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("2.18")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("United Arab Emirates"), _c('sup', [_vm._v("d")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("97.80")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("1,458")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("2.50")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Russia")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("60.00")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("107,476")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("10.32")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Libya")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("44.10")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("2,060")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("0.44")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Nigeria")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("37.20")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("2,068")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("2.18")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Kazakhstan")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("30.00")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("1,256")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("1.60")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Qatar")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("25.38")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("513")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("0.81")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("United States")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("20.68")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("373,648")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("5.60")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("China")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("20.35")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("71,552")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("4.09")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Brazil"), _c('sup', [_vm._v("e")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("13.99")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("11,797")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("2.08")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Algeria")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("12.20")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("2,014")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("1.27")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Mexico")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("10.16")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("7,476")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("2.54")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Angola")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("9.50")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("1,321")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("1.64")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Azerbaijan")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("7.00")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("62")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("0.93")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Ecuador")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("7.21")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("3,447")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("0.50")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("India")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("8.93")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("3,719")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("0.78")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Norway")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("5.32")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("812")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("1.74")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Oman")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("5.50")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("2,286")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("0.89")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Neutral Zone (Iraq/Saudi Arabia)")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("5.00")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("761")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("0.59")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px",
      "border-bottom": "1px solid #b9813d"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Sudan"), _c('sup', [_vm._v("f")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px",
      "border-bottom": "1px solid #b9813d"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("5.00")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px",
      "border-bottom": "1px solid #b9813d"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("42")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px",
      "border-bottom": "1px solid #b9813d"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("0.47")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau_source"
  }, [_c('i', [_vm._v("Source: Oil & Gas Journal")]), _vm._v(" survey data as of Jan. 1, 2012.")]), _vm._v(" "), _c('div', {
    staticClass: "tabtit"
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('sup', [_vm._v("a")]), _vm._v(" Only nations with at least 5.0 billion barrels of estimated reserves are shown.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant"
  }, [_c('sup', [_vm._v("b")]), _vm._v(" All reserves are reported as proved reserves recoverable with current technology and prices except those for Russia; that ﬁgure includes proved plus some probable. Reserves data for Canada includes tar sands.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant"
  }, [_c('sup', [_vm._v("c")]), _vm._v(" Well count does not include shut-in, injection, or service wells.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant"
  }, [_c('sup', [_vm._v("d")]), _vm._v(" Abu Dhabi has 94.3% of the reserves in the seven United Arab Emirates.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant"
  }, [_c('sup', [_vm._v("e")]), _vm._v(" Brazil may have 50–100 billion barrels of additional reserves in presalt offshore formations.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant"
  }, [_c('sup', [_vm._v("f")]), _vm._v(" South Sudan gained independence from Sudan on July 9, 2011; no separate data for South Sudan were available for presentation in this book."), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_18",
      "title": "18"
    }
  })])])]), _vm._v(" "), _c('figure', {
    staticClass: "fig",
    attrs: {
      "id": "fig2-1"
    }
  }, [_c('div', {
    staticClass: "imagelarge"
  }, [_c('img', {
    staticClass: "imagelarge",
    attrs: {
      "alt": "Illustration. Fig. 2–1. Distribution of proved worldwide oil reserves: 1989, 1999, and 2009 (billion barrels) (Source: BP Statistical Review of World Energy 2010, June 2010)",
      "src": "images/fig2-1.jpg"
    }
  })]), _vm._v(" "), _c('figcaption', {
    staticClass: "leg"
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "mev1"
  }, [_vm._v("Fig. 2–1.")]), _vm._v(" Distribution of proved worldwide oil reserves: 1989, 1999, and 2009 (billion barrels) ("), _c('i', [_vm._v("Source: BP Statistical Review of World Energy 2010")]), _vm._v(", June 2010)")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau",
    attrs: {
      "id": "tab-004"
    }
  }, [_c('div', {
    staticClass: "tabtit"
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "mev1"
  }, [_vm._v("Table 2–3.")]), _vm._v(" Top non–U.S.-based energy companies in oil production and reserves, 2011")])]), _vm._v(" "), _c('div', {
    staticClass: "table-align"
  }, [_c('table', {
    staticStyle: {
      "border-collapse": "collapse",
      "border-spacing": "0px"
    }
  }, [_c('colgroup', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('col', {
    staticStyle: {
      "width": "32%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "31%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "padding": "1px"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px",
      "background-color": "#b9813d"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche",
    staticStyle: {
      "color": "#ffffff"
    }
  }, [_c('b', [_vm._v("Company")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px",
      "background-color": "#b9813d"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre",
    staticStyle: {
      "color": "#ffffff"
    }
  }, [_c('b', [_vm._v("Production, million barrels")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px",
      "background-color": "#b9813d"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre",
    staticStyle: {
      "color": "#ffffff"
    }
  }, [_c('b', [_vm._v("Reserves, million barrels")])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Saudi Arabian Oil")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("2,920.0")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("260,100.0")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("National Iranian Oil")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("1,350.5")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("137,010.0")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Pemex")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("957.0")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("10,359.1")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("BP")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("866.0")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("10,530.0")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Iraq National Oil")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("861.4")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("115,000.0")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("PetroChina")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("858.0")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("11,278.0")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("OAO Rosneft")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("847.4")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("18,110.0")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("PdVSA")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("814.0")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("211,170.0")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Abu Dhabi National Oil")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("789.1")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("92,200.0")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Petrobras")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("783.3")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("10,757.2")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Kuwait Petroleum")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("741.0")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("101,500.0")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("OAO Lukoil")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("708.1")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("13,025.0")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Nigerian National Petroleum")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("666.1")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("37,200.0")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px",
      "border-bottom": "1px solid #b9813d"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Sonangol")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px",
      "border-bottom": "1px solid #b9813d"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("653.4")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px",
      "border-bottom": "1px solid #b9813d"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("9,500.0")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau_source"
  }, [_c('i', [_vm._v("Source: Oil & Gas Journal")]), _vm._v(", October 3, 2011,"), _c('i', [_vm._v(" OGJ100")]), _vm._v(" survey data.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_19",
      "title": "19"
    }
  }, [_vm._v("For example, Statoil expressed optimism in April 2011 about a new oil find about 125 miles offshore Norway that it said could hold as much as 500 million boe."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "apnf",
    attrs: {
      "href": "#/chap2#NFIN5",
      "id": "ap_NFIN5-1"
    }
  }, [_vm._v("5")])]), _vm._v(" The new field is about 60 miles north of the company’s Snøhvit gas field, which was the first Norwegian energy project in the Arctic. The Norwegian Petroleum Directorate estimates that the country’s portion of the Barents Sea could hold as much as 6 billion boe.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In August 2011, ExxonMobil entered into a joint venture with Rosneft that included (among other terms) opportunities to explore in a Russian sector of the Arctic Ocean."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "apnf",
    attrs: {
      "href": "#/chap2#NFIN6",
      "id": "ap_NFIN6-1"
    }
  }, [_vm._v("6")])]), _vm._v(" An initial ExxonMobil investment of $2.2 billion is envisioned for activities in the Kara Sea, between the northern coast of European Russia and the Novaya Zemlya island chain. (A similar deal, proposed earlier in the year by BP, fell through.)")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The Arctic wilderness poses special risks, ranging from drifting icebergs to hostile weather. Industry experts, however, have contended that exploration, while environmentally sensitive, is not technically difficult in comparison with areas such as the deep waters of the Gulf of Mexico. They expect that drilling will be in relatively shallow waters and that there would be fewer storms in the region. Changing global climate conditions may lead to expansion of open water in the Arctic in the years ahead.")])]), _vm._v(" "), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-010"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Recent Trends in U.S. Oil Production")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In the United States, domestic oil production declined steadily from 1985 to 2008. However, that trend was reversed by the successful exploitation of unconventional reserves such as shale oil, using two technologies: directional drilling and hydraulic fracturing (described in "), _c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#chap-005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 5")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("As of early February 2011, onshore drilling for oil had risen to almost twice the level seen one year earlier, with 818 oil-directed rigs in operation. This was the highest number since 1987, according to the oil service company Baker Hughes.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Figure 2–2 presents data from EIA on U.S. domestic oil production in recent years. Tables 2–4 and 2–5 present information on liquids reserves and liquids production, respectively, for the U.S.-based companies that comprise the top 15 in domestic reserves and domestic production."), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_20",
      "title": "20"
    }
  })]), _vm._v(" "), _c('figure', {
    staticClass: "fig",
    attrs: {
      "id": "fig2-2"
    }
  }, [_c('div', {
    staticClass: "imagelarge"
  }, [_c('img', {
    staticClass: "imagelarge",
    attrs: {
      "alt": "Illustration. Fig. 2–2. U.S. oil production, annual average: 1995–2010 (million b/d, including crude oil and lease condensate) (Source: EIA)",
      "src": "images/fig2-2.jpg"
    }
  })]), _vm._v(" "), _c('figcaption', {
    staticClass: "leg"
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "mev1"
  }, [_vm._v("Fig. 2–2.")]), _vm._v(" U.S. oil production, annual average: 1995–2010 (million b/d, including crude oil and lease condensate) ("), _c('i', [_vm._v("Source:")]), _vm._v(" EIA)")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau",
    attrs: {
      "id": "tab-005"
    }
  }, [_c('div', {
    staticClass: "tabtit"
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "mev1"
  }, [_vm._v("Table 2–4. ")]), _vm._v("Top U.S.-based energy companies in domestic liquids reserves, 2011")])]), _vm._v(" "), _c('div', {
    staticClass: "table-align"
  }, [_c('table', {
    staticStyle: {
      "border-collapse": "collapse",
      "border-spacing": "0px"
    }
  }, [_c('colgroup', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('col', {
    staticStyle: {
      "width": "33%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "33%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "padding": "1px"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px",
      "background-color": "#b9813d"
    }
  }), _c('td', {
    staticStyle: {
      "padding": "1px",
      "background-color": "#b9813d"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre",
    staticStyle: {
      "color": "#ffffff"
    }
  }, [_c('b', [_vm._v("Liquids reserves, million barrels")])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px",
      "background-color": "#b9813d"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche",
    staticStyle: {
      "color": "#ffffff"
    }
  }, [_c('b', [_vm._v("Company")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px",
      "background-color": "#b9813d"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre",
    staticStyle: {
      "color": "#ffffff"
    }
  }, [_c('b', [_vm._v("United States")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px",
      "background-color": "#b9813d"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre",
    staticStyle: {
      "color": "#ffffff"
    }
  }, [_c('b', [_vm._v("Worldwide")])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("ExxonMobil")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("1,952.0")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("9,418.0")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("ConocoPhillips")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("1,934.0")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("3,616.0")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Occidental Petroleum")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("1,697.0")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("2,476.0")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Chevron")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("1,275.0")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("6,503.0")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Apache")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("759.0")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("1,308.7")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Devon Energy")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("597.0")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("1,160.0")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Pioneer Natural Resources")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("544.9")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("565.0")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("EOG Resources")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("505.9")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("537.8")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Anadarko Petroleum")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("498.0")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("749.0")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Denbury Resources")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("338.3")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("338.3")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Hess")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("304.0")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("1,104.0")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Whiting Petroleum")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("254.3")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("254.3")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Sandridge Energy")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("252.1")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("252.1")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Noble Energy")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("225.0")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("365.0")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px",
      "border-bottom": "1px solid #b9813d"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Continental Resources")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px",
      "border-bottom": "1px solid #b9813d"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("224.8")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px",
      "border-bottom": "1px solid #b9813d"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("224.8")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau_source"
  }, [_c('i', [_vm._v("Source: Oil & Gas Journal")]), _vm._v(", October 3, 2011,"), _c('i', [_vm._v(" OGJ150")]), _vm._v(" survey data.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("EIA also reported that, in 2010, the United States was still importing about 50% of its oil, even though domestic output of crude oil and related liquids rose by 3% compared to 2009—the highest level in almost a decade. The major reason for the increase was (as noted above) the wider use of unconventional extraction methods to exploit onshore resources.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("More specifically, EIA said that domestic production of crude oil and related liquids rose to an average of 7.51 million b/d in 2010, the highest since 2002. The increase made possible a 2% drop in U.S. crude oil imports, to 9.45 million b/d, despite rising demand as the economy recovered. Table 2–6 shows the nations from which the United States imported most (approximately 82%) of its crude oil in 2010, as well as preliminary crude import data for 2011. Table 2–7 provides similar information on 2010 total petroleum imports (crude plus products) for five other nations and Europe."), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_21",
      "title": "21"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tableau",
    attrs: {
      "id": "tab-006"
    }
  }, [_c('div', {
    staticClass: "tabtit"
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "mev1"
  }, [_vm._v("Table 2–5.")]), _vm._v(" Top U.S.-based energy companies in domestic liquids production, 2011")])]), _vm._v(" "), _c('div', {
    staticClass: "table-align"
  }, [_c('table', {
    staticStyle: {
      "border-collapse": "collapse",
      "border-spacing": "0px"
    }
  }, [_c('colgroup', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('col', {
    staticStyle: {
      "width": "33%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "33%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "padding": "1px"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px",
      "background-color": "#b9813d"
    }
  }), _c('td', {
    staticStyle: {
      "padding": "1px",
      "background-color": "#b9813d"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre",
    staticStyle: {
      "color": "#ffffff"
    }
  }, [_c('b', [_vm._v("Annual liquids production, million barrels")])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px",
      "background-color": "#b9813d"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche",
    staticStyle: {
      "color": "#ffffff"
    }
  }, [_c('b', [_vm._v("Company")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px",
      "background-color": "#b9813d"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre",
    staticStyle: {
      "color": "#ffffff"
    }
  }, [_c('b', [_vm._v("United States")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px",
      "background-color": "#b9813d"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre",
    staticStyle: {
      "color": "#ffffff"
    }
  }, [_c('b', [_vm._v("Worldwide")])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Chevron")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("178.0")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("702.0")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("ConocoPhillips")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("139.0")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("318.0")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("ExxonMobil")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("123.0")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("709.0")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Occidental Petroleum")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("99.0")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("201.0")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Anadarko Petroleum")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("47.0")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("73.0")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Devon Energy")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("44.0")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("73.0")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Apache")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("40.3")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("125.1")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("EOG Resources")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("33.9")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("38.4")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Hess")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("32.0")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("112.0")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Marathon Oil")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("25.0")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("89.0")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Denbury Resources")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("21.9")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("21.9")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Whiting Petroleum")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("19.0")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("19.0")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Noble Energy")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("19.0")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("31.0")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Pioneer Natural Resources")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("17.5")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("31.8")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px",
      "border-bottom": "1px solid #b9813d"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Plains Exploration & Production")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px",
      "border-bottom": "1px solid #b9813d"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("16.8")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px",
      "border-bottom": "1px solid #b9813d"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("16.8")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau_source"
  }, [_c('i', [_vm._v("Source: Oil & Gas Journal")]), _vm._v(", October 3, 2011,"), _c('i', [_vm._v(" OGJ150")]), _vm._v(" survey data.")])]), _vm._v(" "), _c('div', {
    staticClass: "tableau",
    attrs: {
      "id": "tab-007"
    }
  }, [_c('div', {
    staticClass: "tabtit"
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "mev1"
  }, [_vm._v("Table 2–6. ")]), _vm._v("U.S. crude oil import sources: Top 10 countries (million b/d)")])]), _vm._v(" "), _c('div', {
    staticClass: "table-align"
  }, [_c('table', {
    staticStyle: {
      "border-collapse": "collapse",
      "border-spacing": "0px"
    }
  }, [_c('colgroup', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('col', {
    staticStyle: {
      "width": "33%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "33%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "padding": "1px"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px",
      "background-color": "#b9813d"
    }
  }), _c('td', {
    staticStyle: {
      "padding": "1px",
      "background-color": "#b9813d"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre",
    staticStyle: {
      "color": "#ffffff"
    }
  }, [_c('b', [_vm._v("Crude imports to U.S., million b/d")])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px",
      "background-color": "#b9813d"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche",
    staticStyle: {
      "color": "#ffffff"
    }
  }, [_c('b', [_vm._v("Country")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px",
      "background-color": "#b9813d"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre",
    staticStyle: {
      "color": "#ffffff"
    }
  }, [_c('b', [_vm._v("2010")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px",
      "background-color": "#b9813d"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre",
    staticStyle: {
      "color": "#ffffff"
    }
  }, [_c('b', [_vm._v("2011 (prelim)")])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Canada")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_vm._v("1.970")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_vm._v("2.213")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Mexico")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_vm._v("1.152")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_vm._v("1.117")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Saudi Arabia")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_vm._v("1.082")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_vm._v("1.259")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Nigeria")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_vm._v("0.983")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_vm._v("0.757")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Venezuela")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_vm._v("0.912")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_vm._v("0.865")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Iraq")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_vm._v("0.415")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_vm._v("0.458")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Angola")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_vm._v("0.383")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_vm._v("0.315")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Colombia")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_vm._v("0.338")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_vm._v("0.403")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Algeria")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_vm._v("0.328")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_vm._v("0.189")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px",
      "border-bottom": "1px solid #b9813d"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Ecuador")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px",
      "border-bottom": "1px solid #b9813d"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_vm._v("0.210")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px",
      "border-bottom": "1px solid #b9813d"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_vm._v("0.228")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau_source"
  }, [_c('i', [_vm._v("Source:")]), _vm._v(" U.S. DOE/EIA. Published in"), _c('i', [_vm._v(" Oil & Gas Journal")]), _vm._v(", Jan. 9, 2012, p. 31. Note: Includes imports for the Strategic Petroleum Reserve."), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_22",
      "title": "22"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "tableau",
    attrs: {
      "id": "tab-008"
    }
  }, [_c('div', {
    staticClass: "tabtit"
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "mev1"
  }, [_vm._v("Table 2–7. ")]), _vm._v("Major sources of petroleum imports for selected countries/regions, 2010")])]), _vm._v(" "), _c('div', {
    staticClass: "table-align"
  }, [_c('table', {
    staticStyle: {
      "border-collapse": "collapse",
      "border-spacing": "0px"
    }
  }, [_c('colgroup', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('col', {
    staticStyle: {
      "width": "11%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "13%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "12%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "12%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "12%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "12%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "12%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "padding": "1px"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px",
      "background-color": "#b9813d"
    },
    attrs: {
      "colspan": "8"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre",
    staticStyle: {
      "color": "#ffffff"
    }
  }, [_c('b', [_vm._v("From:")])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px",
      "background-color": "#b9813d"
    }
  }, [_c('p', {
    staticClass: "txt_courant",
    staticStyle: {
      "color": "#ffffff"
    }
  }, [_c('b', [_vm._v("Imports to:")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px",
      "background-color": "#b9813d"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre",
    staticStyle: {
      "color": "#ffffff"
    }
  }, [_c('b', [_vm._v("Europe")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px",
      "background-color": "#b9813d"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre",
    staticStyle: {
      "color": "#ffffff"
    }
  }, [_c('b', [_vm._v("United States")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px",
      "background-color": "#b9813d"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre",
    staticStyle: {
      "color": "#ffffff"
    }
  }, [_c('b', [_vm._v("Former Soviet Union")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px",
      "background-color": "#b9813d"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre",
    staticStyle: {
      "color": "#ffffff"
    }
  }, [_c('b', [_vm._v("Middle East")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px",
      "background-color": "#b9813d"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre",
    staticStyle: {
      "color": "#ffffff"
    }
  }, [_c('b', [_vm._v("West Africa")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px",
      "background-color": "#b9813d"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre",
    staticStyle: {
      "color": "#ffffff"
    }
  }, [_c('b', [_vm._v("North Africa")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px",
      "background-color": "#b9813d"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre",
    staticStyle: {
      "color": "#ffffff"
    }
  }, [_c('b', [_vm._v("South/Central America")])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Canada")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("217")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("124")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p')]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p')]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("137")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p')]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p')])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Mexico")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("90")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("477")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p')]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p')]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p')]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p')]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("26")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Europe")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p')]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p')]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("5,982")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_vm._v("2,355")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p')]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_vm._v("1,677")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p')])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("China")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p')]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p')]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("676")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_vm._v("2,383")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("878")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p')]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p')])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("India")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p')]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p')]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p')]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_vm._v("2,612")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("428")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p')]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("193")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px",
      "border-bottom": "1px solid #b9813d"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Japan")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px",
      "border-bottom": "1px solid #b9813d"
    }
  }, [_c('p')]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px",
      "border-bottom": "1px solid #b9813d"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("95")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px",
      "border-bottom": "1px solid #b9813d"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("293")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px",
      "border-bottom": "1px solid #b9813d"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_vm._v("3,629")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px",
      "border-bottom": "1px solid #b9813d"
    }
  }, [_c('p')]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px",
      "border-bottom": "1px solid #b9813d"
    }
  }, [_c('p')]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px",
      "border-bottom": "1px solid #b9813d"
    }
  }, [_c('p')])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau_source"
  }, [_c('i', [_vm._v("Source: BP Statistical Review of World Energy 2011")]), _vm._v(", June 2011: Inter-area movements (oil).")]), _vm._v(" "), _c('div', {
    staticClass: "tabtit"
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Note: Figures are given in thousand b/d and include imports of crude oil as well as petroleum products.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-011"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Products Created from Oil")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Because of its high energy density, easy transportability, and relative abundance, oil has been the world’s most important source of energy since the mid-1950s. Refineries convert crude oil into a wide range of products. The refining processes used to achieve this conversion are described in "), _c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap11#chap-011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 11")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("According to EIA, a 42-gallon barrel of crude oil typically yields 44 gallons of petroleum products (owing to a phenomenon called"), _c('i', [_vm._v(" refinery gain")]), _vm._v("). About 85% of the product yield (fig. 2–3) consists of liquid fuels, including gasoline, diesel fuel, kerosene, jet fuel, fuel oil, and propane. The 15% of the petroleum not used to create liquid fuels, according to EIA, is used as a raw material for producing a wide range of chemical products, including fertilizers, pesticides, pharmaceuticals, solvents, and plastics.")]), _vm._v(" "), _c('figure', {
    staticClass: "fig",
    attrs: {
      "id": "fig2-3"
    }
  }, [_c('div', {
    staticClass: "imagelarge"
  }, [_c('img', {
    staticClass: "imagelarge",
    attrs: {
      "alt": "Illustration. Fig. 2–3. Products made in the U.S. from a barrel of crude oil, 2009 (gallons) (Source: DOE)",
      "src": "images/fig2-3.jpg"
    }
  })]), _vm._v(" "), _c('figcaption', {
    staticClass: "leg"
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "mev1"
  }, [_vm._v("Fig. 2–3.")]), _vm._v(" Products made in the U.S. from a barrel of crude oil, 2009 (gallons) ("), _c('i', [_vm._v("Source:")]), _vm._v(" DOE)")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_23",
      "title": "23"
    }
  }, [_vm._v("Certain types of hydrocarbons produced during refining can be mixed with nonhydrocarbons to create other products, such as greases, asphalt, petroleum coke, sulfur, sulfuric acid, and wax. More details on this subject are presented in "), _c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap11#chap-011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 11")]), _vm._v(".")])])]), _vm._v(" "), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-012"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Recent Trends in Oil Consumption")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Global use of oil has been on a steady upward trajectory for decades, as nations around the world have used oil-based fuels to expand their industries and economies (fig. 2–4). Global demand in 2007 reached about 86 million b/d but fell in both 2008 and 2009 as a global financial crisis (triggered mainly by mortgage lending and related activities) depressed investment and dampened economic activity. The figure for 2009 was 84.1 million b/d. For 2010, DOE reported that total world oil consumption resumed its upward trend, reaching about 87.9 million b/d and setting a new record.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("At the 2009 global consumption rate of about 84.1 million b/d (30.7 billion barrels per year) and using the"), _c('i', [_vm._v(" Oil & Gas Journal")]), _vm._v(" estimate of proved oil reserves (1.35 trillion barrels), the remaining oil supply would last about 44 years. Using the DOE reserves estimate of 3.74 trillion barrels (which includes oil sands), the remaining oil supply would last about 122 years.")]), _vm._v(" "), _c('figure', {
    staticClass: "fig",
    attrs: {
      "id": "fig2-4"
    }
  }, [_c('div', {
    staticClass: "imagelarge"
  }, [_c('img', {
    staticClass: "imagelarge",
    attrs: {
      "alt": "Illustration. Fig. 2–4. Global oil consumption: 1995–2009 (million b/d) (Source: Adapted from BP Statistical Review of World Energy 2010, June 2010)",
      "src": "images/fig2-4.jpg"
    }
  })]), _vm._v(" "), _c('figcaption', {
    staticClass: "leg"
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "mev1"
  }, [_vm._v("Fig. 2–4.")]), _vm._v(" Global oil consumption: 1995–2009 (million b/d) ("), _c('i', [_vm._v("Source:")]), _vm._v(" Adapted from"), _c('i', [_vm._v(" BP Statistical Review of World Energy 2010")]), _vm._v(", June 2010)")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_24",
      "title": "24"
    }
  }, [_vm._v("Looking just at the United States, about two-thirds of all oil use is for transportation, according to DOE (fig. 2–5). In other nations, oil is more commonly used for space heating and power generation than for transportation.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Totals include such products as asphalt, road oil, kerosene, LP gases, lubricants, and petroleum coke, as well as gasoline, diesel, aviation fuels, heating oil, and residual fuel oil. Other petroleum products commonly used for transportation include diesel fuel (used for trucks, buses, railroads, some vessels, and a few passenger autos), jet fuel, and residual fuel oil (used for tankers and other large vessels).")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In nontransportation uses—such as space heating, industrial operations, and power generation—substitution of other energy sources for oil has been much easier than in the transportation sector. As a result, U.S. nontransportation use of oil fell from a peak of 8.7 million b/d in 1978 (about 47% of total oil use) to a low of less than 6 million b/d in the late 1980s and early 1990s. Consumption in these sectors has risen to 6.5–7.0 million b/d more recently. Oil accounts for less than 20% of the energy consumed for stationary uses, down from 30% in 1973.")]), _vm._v(" "), _c('figure', {
    staticClass: "fig",
    attrs: {
      "id": "fig2-5"
    }
  }, [_c('div', {
    staticClass: "imagelarge"
  }, [_c('img', {
    staticClass: "imagelarge",
    attrs: {
      "alt": "Illustration. Fig. 2–5. U.S. petroleum consumption by sector: 1995–2009 (million barrels) (Source: U.S. Department of Energy; Annual Energy Review 2009)",
      "src": "images/fig2-5.jpg"
    }
  })]), _vm._v(" "), _c('figcaption', {
    staticClass: "leg"
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "mev1"
  }, [_vm._v("Fig. 2–5.")]), _vm._v(" U.S. petroleum consumption by sector: 1995–2009 (million barrels) ("), _c('i', [_vm._v("Source:")]), _vm._v(" U.S. Department of Energy;"), _c('i', [_vm._v(" Annual Energy Review 2009")]), _vm._v(")")])])])]), _vm._v(" "), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-013"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_25",
      "title": "25"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Projected Trends in Oil Consumption")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In July 2010, DOE published its"), _c('i', [_vm._v(" International Energy Outlook 2010")]), _vm._v(". The study’s reference case scenario projects that total global consumption of liquid fuels will grow to 110.6 million b/d in 2035 as world economic growth resumes (fig. 2–6). DOE expects an annual growth rate of 3.4% in world gross domestic product over its projection period of 2007–2035. DOE includes as liquid fuels not only products derived from conventional resources (chiefly crude oil) but also products derived from unconventional sources (biofuels, oil sands, extra-heavy oil, coal-to-liquids, gas-to-liquids, and shale oil) and natural gas liquids.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In an early release (December 2010) of its"), _c('i', [_vm._v(" Annual Energy Outlook")]), _vm._v(" for 2011, EIA said it expected increased oil production from the members of OPEC, as well as Russia, Kazakhstan, Brazil, and Canada. The agency also said it expected a moderate increase (in real terms) in the price of oil, from about $88 per barrel in mid-December 2010 to $125 in 2009 dollars (about $200 in nominal terms) by 2035.")]), _vm._v(" "), _c('figure', {
    staticClass: "fig",
    attrs: {
      "id": "fig2-6"
    }
  }, [_c('div', {
    staticClass: "imagelarge"
  }, [_c('img', {
    staticClass: "imagelarge",
    attrs: {
      "alt": "Illustration. Fig. 2–6. World liquids consumption by region and country group: 2007–2035 (million b/d) (Source: DOE, International Energy Outlook 2010)",
      "src": "images/fig2-6.jpg"
    }
  })]), _vm._v(" "), _c('figcaption', {
    staticClass: "leg"
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "mev1"
  }, [_vm._v("Fig. 2–6.")]), _vm._v(" World liquids consumption by region and country group: 2007–2035 (million b/d) ("), _c('i', [_vm._v("Source:")]), _vm._v(" DOE,"), _c('i', [_vm._v(" International Energy Outlook 2010")]), _vm._v(")")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_26",
      "title": "26"
    }
  }, [_vm._v("Another agency that produces well regarded forward-looking views of world oil consumption is the International Energy Agency (IEA), based in Paris. IEA released its"), _c('i', [_vm._v(" World Energy Outlook")]), _vm._v(" in November 2010. Its central analysis—the New Policies Scenario (NPS)—assumes that nations around the world take some steps to address concerns about global climate change, but not the aggressive actions urged by IEA itself. The NPS makes the following projections concerning oil use through the year 2035:")])]), _vm._v(" "), _c('ul', {
    staticClass: "liste_puce"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_vm._v("Oil demand (excluding biofuels) reaches 99 million b/d by 2035. All of the net growth comes from non-OECD countries (almost half from China alone). OECD is the Organization for Economic Cooperation and Development.")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_vm._v("Crude oil production reaches about 68 million b/d by 2020 but never regains its all-time peak level of 70 million b/d reached in 2006.")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_vm._v("Oil from unconventional sources (e.g., shale, tar sands, and extraheavy oil) meets about 10% of total world oil demand by 2035 (compared to 3% in 2009). Canadian oil-sands production reaches 4.2 million b/d in 2035 (compared to 1.3 million b/d in 2009).")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_vm._v("Oil production from the Caspian Sea region grows from 2.9 million b/d in 2009 to about 5.2 million b/d in 2035. Financing and multination pipeline construction challenges could constrain this development.")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("With regard to the United States, EIA issued its"), _c('i', [_vm._v(" Annual Energy Outlook 2011")]), _vm._v(" ("), _c('i', [_vm._v("AEO2011")]), _vm._v(") in April 2011, examining U.S. energy trends through 2035. In the study’s reference case, total U.S. consumption of liquid fuels, including both fossil liquids and biofuels, grows from 18.6 million b/d (36.2 quadrillion Btu [quads] per year) in 2009 to 21.4 million b/d (41.7 quads per year) in 2035 (fig. 2–7).")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The transportation sector dominates demand for liquid fuels in"), _c('i', [_vm._v(" AEO2011")]), _vm._v(", but its share (as measured by energy content) grows only slightly—from 72% of total liquids consumption in 2009 to 74% in 2035. Biofuel consumption accounts for most of the growth. The biofuel portion of liquid fuels consumption is about 1.89 million b/d equivalent (3.9 quads per year) in 2035. Oil consumption is expected to remain roughly unchanged by 2035, at about 20 million b/d."), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_27",
      "title": "27"
    }
  })]), _vm._v(" "), _c('figure', {
    staticClass: "fig",
    attrs: {
      "id": "fig2-7"
    }
  }, [_c('div', {
    staticClass: "imagelarge"
  }, [_c('img', {
    staticClass: "imagelarge",
    attrs: {
      "alt": "Illustration. Fig. 2–7. U.S. primary energy use by fuel: 1995–2035 (quadrillion Btu/year) (Source: EIA, AEO2011)",
      "src": "images/fig2-7.jpg"
    }
  })]), _vm._v(" "), _c('figcaption', {
    staticClass: "leg"
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "mev1"
  }, [_vm._v("Fig. 2–7.")]), _vm._v(" U.S. primary energy use by fuel: 1995–2035 (quadrillion Btu/year) ("), _c('i', [_vm._v("Source:")]), _vm._v(" EIA,"), _c('i', [_vm._v(" AEO2011")]), _vm._v(")")])])])])])]), _vm._v(" "), _c('section', {
    staticClass: "div_notes",
    attrs: {
      "epub:type": "appendix"
    }
  }, [_c('div', {
    staticClass: "appen",
    attrs: {
      "id": "appen1"
    }
  }, [_c('h1', {
    staticClass: "appen_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("References")])]), _vm._v(" "), _c('section', {
    staticClass: "defnotes",
    attrs: {
      "epub:type": "appendix"
    }
  }, [_c('aside', {
    staticClass: "ntf",
    attrs: {
      "epub:type": "rearnote",
      "id": "NFIN1"
    }
  }, [_c('p', {
    staticClass: "txt_justif"
  }, [_c('a', {
    attrs: {
      "href": "#/chap2#ap_NFIN1-1"
    }
  }, [_vm._v("1")]), _vm._v(". Oil Sands InfoMine. "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://oilsands.infomine.com/countries/",
      "target": "_blank"
    }
  }, [_vm._v("http://oilsands.infomine.com/countries/")]), _vm._v(" (accessed February 21, 2011).")])]), _vm._v(" "), _c('aside', {
    staticClass: "ntf",
    attrs: {
      "epub:type": "rearnote",
      "id": "NFIN2"
    }
  }, [_c('p', {
    staticClass: "txt_justif"
  }, [_c('a', {
    attrs: {
      "href": "#/chap2#ap_NFIN2-1"
    }
  }, [_vm._v("2")]), _vm._v(". Bureau of Land Management, Colorado State Office, Lakewood. Oil shale and tar sands EIS information center. Oil shale/tar sands guide: About oil shale. "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://ostseis.anl.gov/guide/oilshale/index.cfm",
      "target": "_blank"
    }
  }, [_vm._v("http://ostseis.anl.gov/guide/oilshale/index.cfm")]), _vm._v(" (accessed February 21, 2011).")])]), _vm._v(" "), _c('aside', {
    staticClass: "ntf",
    attrs: {
      "epub:type": "rearnote",
      "id": "NFIN3"
    }
  }, [_c('p', {
    staticClass: "txt_justif"
  }, [_c('a', {
    attrs: {
      "href": "#/chap2#ap_NFIN3-1"
    }
  }, [_vm._v("3")]), _vm._v(". U.S. Geological Survey. 2008. 90 Billion barrels of oil and 1,670 trillion cubic feet of natural gas assessed in the Arctic. News release, July 23.")])]), _vm._v(" "), _c('aside', {
    staticClass: "ntf",
    attrs: {
      "epub:type": "rearnote",
      "id": "NFIN4"
    }
  }, [_c('p', {
    staticClass: "txt_justif"
  }, [_c('a', {
    attrs: {
      "href": "#/chap2#ap_NFIN4-1"
    }
  }, [_vm._v("4")]), _vm._v(". Pfeifer, S. 2011. Arctic frontier: Huge prize lies under a pristine wilderness."), _c('i', [_vm._v(" Financial Times")]), _vm._v(", March 21.")])]), _vm._v(" "), _c('aside', {
    staticClass: "ntf",
    attrs: {
      "epub:type": "rearnote",
      "id": "NFIN5"
    }
  }, [_c('p', {
    staticClass: "txt_justif"
  }, [_c('a', {
    attrs: {
      "href": "#/chap2#ap_NFIN5-1"
    }
  }, [_vm._v("5")]), _vm._v(". Ward,A. 2011. Statoil looks to Arctic find to boost prospects. "), _c('i', [_vm._v("Financial Times")]), _vm._v(",April 10.")])]), _vm._v(" "), _c('aside', {
    staticClass: "ntf",
    attrs: {
      "epub:type": "rearnote",
      "id": "NFIN6"
    }
  }, [_c('p', {
    staticClass: "txt_justif"
  }, [_c('a', {
    attrs: {
      "href": "#/chap2#ap_NFIN6-1"
    }
  }, [_vm._v("6")]), _vm._v(". Kramer,A. E. 2011. Exxon wins prized access to Arctic with Russia deal."), _c('i', [_vm._v(" NewYork Times")]), _vm._v(",August 30.")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d5d1248","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chap2.vue
// module id = 75
// module chunks = 0